import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { http, formatApiError } from "@/lib/api";

export const CommentEditor = ({ classId, studentId, entries }) => {
  const [comment, setComment] = useState("");
  const [highlight, setHighlight] = useState("auto");
  useEffect(() => {
    http.get(`/classes/${classId}/students/${studentId}/comment`).then((r) => {
      setComment(r.data.comment || ""); setHighlight(r.data.highlight_entry_id || "auto");
    });
  }, [classId, studentId]);

  const save = async () => {
    try {
      await http.put(`/classes/${classId}/students/${studentId}/comment`, { comment, highlight_entry_id: highlight === "auto" ? null : highlight });
      toast.success("Report card comment saved");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <section className="mt-10 rounded-3xl bg-white/60 border border-[#E6DEC3] p-6" data-testid="comment-editor">
      <p className="text-xs uppercase tracking-widest text-stone-500">Report card · teacher comment & highlight</p>
      <textarea rows={3} value={comment} onChange={(e) => setComment(e.target.value)} data-testid="comment-editor-textarea"
        placeholder="Share growth you've noticed in learning and self-awareness…"
        className="mt-3 w-full p-4 rounded-2xl bg-white border border-[#E6DEC3] text-sm focus:outline-none focus:border-[#2C4A3E]" />
      <div className="flex flex-wrap gap-3 items-center mt-3">
        <Select value={highlight} onValueChange={setHighlight}>
          <SelectTrigger className="rounded-full bg-white border-[#E6DEC3] max-w-md" data-testid="comment-editor-highlight-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="auto">Self-discovery highlight: most recent reflection</SelectItem>
            {entries.filter((e) => e.reflection).map((e) => <SelectItem key={e.id} value={e.id}>{e.subject_name}: {e.reflection.slice(0, 60)}…</SelectItem>)}
          </SelectContent>
        </Select>
        <button onClick={save} data-testid="comment-editor-save-btn" className="px-5 py-2 rounded-full bg-[#2C4A3E] text-white text-sm hover:bg-[#1E352B]">Save</button>
      </div>
    </section>
  );
};
